import React, { Component } from 'react';
import './BrowserNotSupportedMessage.css';
import { getTranslation, getCurrentLang, setLanguage } from '../../assets/creator/translations';
import LanguageSelector from '../LanguageSelector/LanguageSelector';

class BrowserNotSupportedMessage extends Component {
    constructor(props) {
        super(props);
        this.state = { lang: getCurrentLang(), isMenuOpen:false, }
    }

    changeLanguage = (newLang) => {
        setLanguage(newLang);
        this.setState({ lang: newLang });
    }

    render = () => (
        <div className="browser-not-supported">
                <Logo />
                <BrowserList />
                <div className="langs">
                    <LanguageSelector
                        lang={this.state.lang}
                        langChangeHandler={this.changeLanguage}
                    />
                </div>
        </div>
    );
}


export default BrowserNotSupportedMessage;

const Logo = () => (
        <div className="logo">
            <img className="logo__img" src="./img/comarch_logo_mobile_browsers.svg" alt="logo" />
        </div>
)

const BrowserList = () => (
    //disable eslint warning for link messages in browser-logo links
    /* eslint-disable jsx-a11y/anchor-has-content */
    <div className="browsers">
            <h4>{getTranslation("BrowserNotSupported")}</h4>
            <p className='browsers_p'>{getTranslation("UseOneOfBrowsersBelow")}</p>
            <div className='browser-section'>
                <div className='browser-container c'>
                    <a href="https://www.google.com/chrome" />
                </div>
                <div className='browser-container f'>
                    <a href="http://www.mozilla.org/firefox/" />
                </div>
                <div className='browser-container o'>
                    <a href="http://www.opera.com/pl/download" />
                </div>                
                <div className='browser-container e'>
                    <a href="https://www.microsoft.com/microsoft-edge" />
                </div>               
                <div className='browser-container s'>
                    <a href="https://support.apple.com/HT204416" />
                </div>
            </div>


			<span className="border-line"></span>
    </div>
    /* eslint-enable jsx-a11y/anchor-has-content */
)


// WEBPACK FOOTER //
// ./src/components/BrowserNotSupportedMessage/BrowserNotSupportedMessage.js